// utils.js
export function showError(el, msg) {
  el.style.display = "block";
  el.textContent = msg;
}

export function getQueryParams() {
  const p = new URLSearchParams(location.search);
  const o = {};
  for (const [k, v] of p.entries()) o[k.toLowerCase()] = v;
  return o;
}
export function numParam(QP, key, def) {
  const v = QP[key];
  if (v == null) return def;
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
}
export function strParam(QP, key, def) {
  const v = QP[key];
  return (v == null || v === "") ? def : String(v);
}

export function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2*t + 2, 3) / 2;
}
export function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2*t + 2, 2) / 2;
}
export function easeLinear(t) { return t; }

export function makeEase(kind) {
  const k = (kind || "cubic").toLowerCase();
  switch (k) {
    case "linear": return easeLinear;
    case "quad": return easeInOutQuad;
    case "cubic":
    default: return easeInOutCubic;
  }
}

export function animateValue(from, to, ms, easeFn, onFrame) {
  const t0 = performance.now();
  return new Promise(resolve => {
    function tick(now) {
      const t = Math.min(1, (now - t0) / ms);
      const e = easeFn(t);
      onFrame(from + (to - from) * e, t, e);
      if (t < 1) requestAnimationFrame(tick);
      else resolve();
    }
    requestAnimationFrame(tick);
  });
}

export function animateViewTo(view, target, ms, easeFn, applyTransform, onFrame) {
  const from = { tx: view.tx, ty: view.ty, scale: view.scale };
  const t0 = performance.now();
  return new Promise(resolve => {
    function tick(now) {
      const t = Math.min(1, (now - t0) / ms);
      const e = easeFn(t);
      view.tx = from.tx + (target.tx - from.tx) * e;
      view.ty = from.ty + (target.ty - from.ty) * e;
      view.scale = from.scale + (target.scale - from.scale) * e;
      applyTransform();
      if (onFrame) onFrame();
      if (t < 1) requestAnimationFrame(tick);
      else resolve();
    }
    requestAnimationFrame(tick);
  });
 
}
